export function round(value, decimals = 2) {
  if (value == null || Number.isNaN(value)) return null;
  // pre round to avoid floating point issues, but don't clip below target precision
  const preRound = Math.min(Math.max(decimals + 2, 5), 12);
  const newValue = Math.round(value * 10 ** preRound) / 10 ** preRound;
  // round half away from zero so positive/negative values round symmetrically
  // (Math.round rounds halves toward +∞, which left stray cents on offsetting lines)
  const factor = 10 ** decimals;
  return (Math.sign(newValue) * Math.round(Math.abs(newValue) * factor)) / factor;
}
